/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React, { RefObject } from 'react';
import { LottieAnimation } from '../LottieAnimation';
import { useStyles } from './ConfettiHeroAnimations.styles';

type ConfettiHeroAnimationsProps = {
    confettiRef: RefObject<any>;
    heroRef: RefObject<any>;
    confettiAnimationData: any;
    heroAnimationData: any;
};

export const ConfettiHeroAnimations: React.FC<ConfettiHeroAnimationsProps> = ({
    confettiRef,
    heroRef,
    confettiAnimationData,
    heroAnimationData
}) => {
    const styles = useStyles();

    return (
        <>
            {/* Confetti Animation - overlays on top */}
            <LottieAnimation
                ref={confettiRef}
                animationData={confettiAnimationData}
                autoplay={false}
                loop={false}
                stripExpressions={true}
                className={styles.confetti}
            />
            {/* Hero Animation - centered in card */}
            <div className={styles.hero}>
                <LottieAnimation
                    ref={heroRef}
                    animationData={heroAnimationData}
                    autoplay={false}
                    loop={false}
                    className={styles.heroAnimation}
                />
            </div>
        </>
    );
};
